import { Box, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useGetArchivedDocuments } from 'src/api/document'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { CustomerCtx } from 'src/context/CustomerContext'
import { MUIThemeColors } from 'src/mui-theme'
import ArchivedDocumentsTable from 'src/screens/localities/documents/components/ArchivedDocumentsTable'
import { getThemeColor } from 'src/utils'

const ArchivedDocumentsContainer = () => {
  const { id: customerId } = useParams()
  const { data: archivedDocuments, isLoading: isArchivedDocumentsLoading } = useGetArchivedDocuments(
    customerId as EntityId,
    {
      customerId: customerId as EntityId,
    },
  )
  const { t: translate } = useTranslation(['documents', 'common'])
  const theme = useTheme()
  return (
    <CommonPageLayout titleSection={{ title: translate('archived-documents', { ns: 'document' }) }}>
      <Box padding={'8px'} bgcolor={getThemeColor(theme, MUIThemeColors.white)} borderRadius={'4px'}>
        <ArchivedDocumentsTable
          documents={archivedDocuments?.items || []}
          hideColumns={['mooring']}
          customerId={customerId as EntityId}
          context={CustomerCtx}
          isLoading={isArchivedDocumentsLoading}
        />
      </Box>
    </CommonPageLayout>
  )
}
export default ArchivedDocumentsContainer
